import { createRoot } from 'react-dom/client';

import { App } from './App';

(window as any).APP_VERSION = import.meta.env.VITE_APP_VERSION;

// TODO: enable StrictMode
createRoot(document.getElementById('root') as HTMLElement).render(<App />);
